import { mapActions } from 'vuex'

export default {
  name: 'ShopifyAuthCallback',
  data () {
    return {
      isLoading: true,
      error: null,
      success: false,
      contentplanId: null,
      shop: null,
      redirectPath: '/'
    }
  },
  methods: {
    ...mapActions([
      'completeShopifyAuth',
      'getIntegrations'
    ]),
    async processCallback () {
      this.isLoading = true
      try {
        const urlParams = new URLSearchParams(window.location.search)
        const callbackParams = Object.fromEntries(urlParams.entries())
        this.shop = callbackParams.shop

        if (!callbackParams.code || !this.shop || !callbackParams.state || !callbackParams.hmac) throw new Error('Missing required parameters for Shopify OAuth callback')

        this.contentplanId = sessionStorage.getItem('shopify_contentplan_id')
        const workspaceId = sessionStorage.getItem('active_workspace_id')
        const isShopifyInstallOnboarding = sessionStorage.getItem('shopify_install_onboarding') === 'true'

        if (!this.contentplanId || !workspaceId) throw new Error('Missing ContentGecko session data. Please start the connection from the Shopify integration page.')

        this.redirectPath = isShopifyInstallOnboarding
          ? `/workspace/${workspaceId}/contentplan/${this.contentplanId}/home?showSetupMessage=true`
          : `/workspace/${workspaceId}/contentplan/${this.contentplanId}/shopify-integration`

        await this.completeShopifyAuth({ callbackParams })
        await this.getIntegrations({ contentplanId: this.contentplanId })

        this.success = true
        this.isLoading = false

        sessionStorage.removeItem('shopify_store')
        sessionStorage.removeItem('shopify_contentplan_id')
        sessionStorage.removeItem('active_workspace_id')
        sessionStorage.removeItem('shopify_install_onboarding')
        sessionStorage.removeItem('shopify_pending_shop')

        window.location.href = this.redirectPath
      } catch (error) {
        console.error('Error completing Shopify OAuth:', error)
        this.error = error?.response?.data?.message || error.message || 'An error occurred while connecting to Shopify.'
        this.isLoading = false
      }
    }
  },
  mounted () {
    this.processCallback()
  }
}
